var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('pop-ups'),_c('all-modals'),_c('page-header'),_c('router-view')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }